var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer m-0"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"logo-header"},[_vm._v("\n          © Italretail S.r.l. "+_vm._s(_vm.moment().format('YYYY'))+" - P.IVA 01382910352\n        ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }